var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandexmarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 11.35c0-4.997 0-7.495 1.552-9.048C3.855.75 6.353.75 11.35.75h5.3c4.997 0 7.495 0 9.048 1.552 1.552 1.553 1.552 4.051 1.552 9.048v5.3c0 4.997 0 7.495-1.552 9.048-1.553 1.552-4.051 1.552-9.048 1.552h-5.3c-4.997 0-7.495 0-9.048-1.552C.75 24.145.75 21.647.75 16.65v-5.3z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.482 13.997v-3H6.851c-.542 0-.966.132-1.271.397-.302.26-.453.627-.453 1.1 0 .476.151.847.453 1.112.301.26.725.39 1.27.39h1.632zm-1.405 1.258L4.859 18.5H3.087l2.395-3.464c-.595-.172-1.072-.483-1.43-.935-.358-.453-.538-.99-.538-1.614 0-.835.281-1.51.844-2.028.562-.517 1.303-.776 2.224-.776h3.464V18.5H8.482v-3.245H7.077zm5.182 3.373a.937.937 0 0 1-.978-.965c0-.281.092-.511.275-.69a.952.952 0 0 1 .703-.275c.29 0 .524.091.703.274.183.18.275.41.275.69a.937.937 0 0 1-.275.691c-.18.184-.414.275-.703.275zM23.57 18.5h-1.466v-6.202h-.086l-2.438 5.86h-1.124l-2.438-5.86h-.086V18.5h-1.466V9.683h1.845l2.652 6.422h.11l2.652-6.422h1.845V18.5z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 14,
    y1: 0.75,
    x2: 14,
    y2: 27.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F64A1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexmarket);
export default __webpack_public_path__ + "static/media/yandexmarket.02ee31bb8ae454f43ebbd4cf3944adb0.svg";
export { ForwardRef as ReactComponent };